export default __webpack_public_path__ + "static/media/avatar_book1.a92faf02.mp3";